import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'schoolYear'
})
export class SchoolYearPipe implements PipeTransform {
    transform(value: string) {
        if (!value) { return ''; }

        return value.length === 4 ? `20${value.substr(0, 2)} - 20${value.substr(2)}` : `${value.substr(0, 4)} - ${value.substr(4)}`;
    }
}
